import React from "react";

interface IntegrationTicketContentProps {
  children?: React.ReactNode;
}

const IntegrationTicketContent: React.FC<IntegrationTicketContentProps> = ({ children }) => {
  return <div className="integrations-ticket-content">{children}</div>;
};

export default IntegrationTicketContent;
